'use strict';

var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ ["ProjectService", "TrainService", function (ProjectService, TrainService) {
    var factory = {};

    var selectedProjectId;
    var trains;

    factory.trainMap = new Map();

    factory.update = function (projectId) {

        if (!util.isDefined(projectId) || (selectedProjectId === projectId && factory.trainMap.size > 0)) {
            return;
        }

        selectedProjectId = projectId;

        TrainService.getTrains().query({
            "projectId": selectedProjectId
        }).$promise.then(function (newTrains) {
                factory.setManually(newTrains);
            }
        );
    };


    ProjectService.subscribe("TrainService", function (updatedProjectId) {
        if (selectedProjectId !== updatedProjectId) {
            selectedProjectId = updatedProjectId;
            factory.update();
        }
    });

    factory.setManually = function (newTrains) {
        if (!util.isDefined(newTrains)) {
            return;
        }
        factory.trainMap.clear();
        newTrains.forEach(function (train) {
            factory.trainMap.set(train.relativeId, train);
        });
    };

    factory.getAllTrains = function () {
        return trains;
    };

    factory.getRelativeTrain = function (relativeTrainId) {
        return factory.trainMap.get(relativeTrainId);
    };

    factory.getOfficalTrain = function (externalId) {
        return arrayUtil.getFirstInList(trains, "officalId", externalId);
    };

    factory.getTrain = function (dbId) {
        return arrayUtil.getFirstInList(trains, "id", dbId);
    };


    return factory;
}];
